var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.191 34.9629C274.48 25.1851 264.524 18.9629 253.591 18.9629C242.658 18.9629 232.791 25.1851 227.991 34.9629L170.835 152.563L43.1908 171.407C32.5242 173.007 23.6353 180.474 20.3464 190.696C17.0575 200.918 19.7242 212.207 27.3686 219.763L119.991 311.407L98.1242 440.918C96.3464 451.585 100.791 462.43 109.591 468.741C118.391 475.052 130.035 475.852 139.635 470.785L253.68 409.896L367.724 470.785C377.324 475.852 388.969 475.141 397.769 468.741C406.569 462.341 411.013 451.585 409.235 440.918L387.28 311.407L479.902 219.763C487.546 212.207 490.302 200.918 486.924 190.696C483.546 180.474 474.746 173.007 464.08 171.407L336.346 152.563L279.191 34.9629Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.fcd5edeeef85d2e35fa6efbe4d091d65.svg";
export { ForwardRef as ReactComponent };